var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-sliderbox"},[(_vm.show)?_c('div',{staticClass:"modal",on:{"click":function($event){return _vm.$emit('on-mask')}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sliderbox-bd",class:[
     {'show': _vm.show},
     {'fullwidth': !_vm.autowidth},
     {'bottom': _vm.direction === 'bottom'},
     {'left': _vm.direction === 'left'},
     {'right': _vm.direction === 'right'}]},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23ef6a78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sliderbox.vue
// module id = null
// module chunks = 